import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const Agentstatus1 = {
    name: 'Agentstatus1',
    imageUrl: '../../images/Agentstatus.png',
    imageSize: "100%",
    bradius: 20,
  };
  export const Agentstatus = () => {
    return (
      <div style={helpcanvas}>
        <div
        style={{ marginLeft: "310px" }}
        ></div>
        <div style={helptitle}><b>Overall Health Score – Avg </b><br/><br/>
        This section provides an insight into your Overall Health Score, which is calculated by evaluating the number of deployed agents that 
        have successfully checked in against the total count of targets that have been scanned and those that have yet to be scanned.

  <br/><br/>
  <b>Agent Status </b><br/><br/>
  In this category, you will find a breakdown of the status of your agents: <br/><br/>
  <ul style={{marginLeft: '4em'}}>
              <li>Number of agents online</li>
              <li>Number of agents actively checking in</li>
              <li>Agents running in the current version</li>
              <li>Agents behind in your instance</li>
        </ul>
        <br/>
        <b>Target Status</b><br/><br/>  
        This section employs bar charts to visualize the status of your targets in relation to Data, Vulnerability, and Secure Baseline scans: <br/><br/>
  <ul style={{marginLeft: '4em'}}>
              <li>Number of targets that remain unscanned</li>
              <li>Targets scheduled for future scans</li>
              <li>Targets that have already undergone data, vulnerability, and secure baseline scans</li>
              <li>The count of targets equipped with agents</li>
              <li>The total count of targets yet to be scanned</li>
        </ul>
        </div>
        <div style={helpimg}>
        <img
          src={Agentstatus1.imageUrl}
          alt={'Image of ' + Agentstatus1.name}
          style={{
            width: Agentstatus1.imageSize,
            borderRadius: Agentstatus1.bradius,
          }}
        />
        </div>
      </div>
    );
  };
  